<template>
  <div>
    <div class="fee" v-if="appendixFeeTrans.templateFee">
      <p class="title-fee">Template phí:</p>
      <p>{{ appendixFeeTrans.templateFee }}</p>
    </div>
    <div class="fee" v-if="appendixFeeTrans.suggestFee">
      <p class="title-fee">Phí đề xuất:</p>
      <p>{{ appendixFeeTrans.suggestFee }}</p>
    </div>
    <p>Chính sách phí</p>
    <div class="fee" v-for="(mappedItem, index) in mappedItems" :key="index">
      <p class="title-fee">{{ mappedItem.name }}:</p>
      <p>{{ mappedItem.detailName }}</p>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  import mxAppendix from '../../mxAppendix.js'
  export default {
    mixins: [mxAppendix],
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      appendixFeeTrans: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {}
    },
    computed: {
      mappedItems() {
        return this.items.map(item => {
          const config = this.systemConfig.configFeePg.find(cfg => cfg.code === item.code)
          if (config) {
            const detail = config.details?.find(d => d.code === item.detailCode)
            return {
              name: config.name,
              detailName: detail?.name || '',
            }
          }
          return {
            name: '',
            detailName: '',
          }
        })
      },
    },
    created() {
      this.getConfigSystem()
    },
    methods: {},
  }
</script>
<style scoped>
  .fee {
    width: 50%;
    display: flex;
    /* justify-content: space-between; */
  }
  .title-fee {
    margin-right: 10px;
  }
</style>
